import React from "react";

const NameTitleComponent = () => {
  return (
    <div>
      <h2>Marco Gonzalez</h2>
      <h4>Software Engineer</h4>
      <h6>Google Cloud Associate Cloud Engineer Certified</h6>
      <h6>B.S. Computer Science at California State University, Los Angeles</h6>
    </div>
  );
};

export default NameTitleComponent;
